// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScheduledCallsInviteesList__container-e46961 {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  flex: 1;
}

.ScheduledCallsInviteesList__placeholders-de437a {
  padding: 8px 16px;
}

.ScheduledCallsInviteesList__list-c2ac10 {
  box-sizing: border-box;
  flex: 1;
  overflow: hidden;
  display: flex;
}

.ScheduledCallsInviteesList__results-f1bf55 {
  width: 100%;
}

.ScheduledCallsInviteesList__participants-db4ce4 {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--base-110);
  margin-bottom: 8px;
}

.ScheduledCallsInviteesList__placeholder-a8c63d {
  height: 24px;
  margin-bottom: 8px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/ScheduledCalls/ScheduledCallViewPopup/ScheduledCallsInviteesList/ScheduledCallsInviteesList.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,sBAAA;EACA,OAAA;EACA,gBAAA;EACA,aAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,kBAAA;AACF","sourcesContent":[".container {\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  position: relative;\n  flex: 1;\n}\n\n.placeholders {\n  padding: 8px 16px;\n}\n\n.list {\n  box-sizing: border-box;\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n}\n\n.results {\n  width: 100%;\n}\n\n.participants {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--base-110);\n  margin-bottom: 8px;\n}\n\n.placeholder {\n  height: 24px;\n  margin-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ScheduledCallsInviteesList__container-e46961`,
	"placeholders": `ScheduledCallsInviteesList__placeholders-de437a`,
	"list": `ScheduledCallsInviteesList__list-c2ac10`,
	"results": `ScheduledCallsInviteesList__results-f1bf55`,
	"participants": `ScheduledCallsInviteesList__participants-db4ce4`,
	"placeholder": `ScheduledCallsInviteesList__placeholder-a8c63d`
};
module.exports = ___CSS_LOADER_EXPORT___;
